// Third Party Plugins
import React from 'react';
import Gallery from '@components/images/Gallery';
// Types
import { GallerySectionProps } from './types';

const GallerySection: React.FC<GallerySectionProps> = ({
  hasGallery,
  galleryManyBlock,
}) => {
  if (!hasGallery || !galleryManyBlock || galleryManyBlock.length === 0) {
    return null;
  }

  return (
    <Gallery
      images={galleryManyBlock.map((image) => ({
        alt: image.alt || '',
        url: image.asset?.url || '', // Extract the URL from asset to the top level
        asset: image.asset, // Retain the original asset structure
        crop: image.crop, // Include optional crop if available
        hotspot: image.hotspot, // Include optional hotspot if available
      }))}
    />
  );
};

export default GallerySection;
